import React from "react";

import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardTitle,
} from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface HomeBlockProps {
  title: string;
  description: string | React.ReactNode;
  content: React.ReactNode;
  actionLabel?: string;
  isEmpty?: boolean;
  onClick?: () => void;
}

export function HomeBlock({
  title,
  description,
  content,
  actionLabel = "Try Now",
  isEmpty = false,
  onClick,
}: HomeBlockProps) {
  return (
    <Card
      className={cn("group", {
        "hover:border-primary": isEmpty,
      })}
      variant="plain"
      onClick={isEmpty ? onClick : undefined}
    >
      <>
        <CardContent>
          <div className="xs:flex-col flex w-full md:flex-row">
            <div className="xs:p-5 xs:gap-5 flex max-w-103 min-w-50 flex-col md:flex-2 md:gap-6 md:p-6 xl:flex-1">
              <div className="flex flex-col gap-2">
                <CardTitle
                  className={cn(
                    "hover:text-primary xs:text-xl cursor-pointer text-wrap transition-colors duration-300 md:text-2xl",
                    {
                      "group-hover:text-primary": isEmpty,
                    },
                  )}
                  onClick={onClick}
                >
                  {title}
                </CardTitle>
                <CardDescription className="xs:text-sm font-normal text-gray-500 md:text-base">
                  {description}
                </CardDescription>
              </div>
              {isEmpty ? (
                <div>
                  <Button
                    className="px-9 py-1"
                    intent="secondary"
                    size="sm"
                    onClick={onClick}
                  >
                    {actionLabel}
                  </Button>
                </div>
              ) : null}
            </div>
            <div className="xs:hidden xs:my-5 w-px bg-neutral-300 md:my-6 md:block" />
            <hr className="xs:block xs:mx-5 m-0 border-neutral-300 md:mx-6 md:hidden" />
            <div className="min-w-0 md:flex-7 xl:flex-1">{content}</div>
          </div>
        </CardContent>
      </>
    </Card>
  );
}
